import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGraduationCap, faUserFriends, faCog } from "@fortawesome/free-solid-svg-icons";

const RoleCard = ({ icon, title, bgColor, points }) => {
  return (
    <div className="bg-white rounded-xl p-8 shadow-sm">
      <div
        className={`w-12 h-12 ${bgColor} rounded-lg flex items-center justify-center mb-6`}
      >
        <FontAwesomeIcon icon={icon} className="text-[#4f6ef7] text-xl" />
      </div>
      <h3 className="font-bold text-lg mb-4">{title}</h3>
      <div className="space-y-4 text-md text-[#334155]">
        {points.map((point, index) => (
          <div key={index}>
            <p className="font-semibold text-black">{point.title}</p>
            <p>{point.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};


const roles = [
  {
    icon: faGraduationCap,
    title: "Teachers",
    bgColor: "bg-[#e0e7ff]",
    points: [
      { title: "AI-Powered Lesson Planning", description: "Create engaging, standards-aligned lessons in minutes" },
      { title: "Smart Differentiation", description: "Automatically adapt content for every student's needs" },
      { title: "Effortless Grading", description: "Save hours with intelligent assessment tools" },
      { title: "Real-Time Analytics", description: "Track student progress with actionable insights" },
    ],
  },
  {
    icon: faUserFriends,
    title: "Students",
    bgColor: "bg-[#e0e7ff]",
    points: [
      { title: "Personalized Learning", description: "Experience education tailored to your unique style" },
      { title: "Interactive Content", description: "Engage with dynamic, adaptive materials" },
      { title: "Immediate Feedback", description: "Get instant support when you need it" },
      { title: "Track Your Progress", description: "Watch your growth in real-time" },
    ],
  },
  {
    icon: faCog,
    title: "Administrators",
    bgColor: "bg-[#e0e7ff]",
    points: [
      { title: "Comprehensive Oversight", description: "Monitor school-wide performance at a glance" },
      { title: "Data-Driven Decisions", description: "Make informed choices with advanced analytics" },
      { title: "Standards Compliance", description: "Ensure alignment with state and national requirements" },
      { title: "Streamlined Operations", description: "Reduce administrative burden with automation" },
    ],
  },
  {
    icon: faUserFriends,
    title: "Parents",
    bgColor: "bg-[#e0e7ff]",
    points: [
      { title: "Stay Connected", description: "Follow your child's educational journey in real-time" },
      { title: "Direct Communication", description: "Easily connect with teachers and staff" },
      { title: "Progress Tracking", description: "Monitor assignments, grades, and achievements" },
      { title: "Active Participation", description: "Support learning at home with suggested activities" },
    ],
  },
];

const EducationRoles = () => {
  return (
    <div className="bg-gradient-to-r from-[#e9efff] via-[#f7f5f7] to-[#f7f5f7] min-h-screen ">
      <main className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 py-16 ">
      <div className="text-center max-w-2xl mx-auto mb-12">
        <h2 className="text-3xl font-extrabold leading-tight">
          Tailored for Every Role in Education
        </h2>
        <p className="mt-2 text-[#334155] text-base font-normal">
          Discover features designed specifically for your educational needs
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {roles.map((role) => (
          <RoleCard
            key={role.title}
            icon={role.icon}
            title={role.title}
            bgColor={role.bgColor}
            points={role.points}
          />
        ))}
      </div>
    </main>
    </div>

  );
};

export default EducationRoles;